import './Accounts.css';
import { useState } from 'react';
import data from '../../assets/data.json';

function Accounts() {
    const [accounts, setAccounts] = useState(data);
    const [newAccount, setNewAccount] = useState({ name: '', email: '', balance: '' });
    const [transaction, setTransaction] = useState({ amount: '', accountId: null });
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [showAccountForm, setShowAccountForm] = useState(false);
    const [showTransfer, setShowTransfer] = useState(false);
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [sender, setSender] = useState("");
    const [receiver, setReceiver] = useState("");
    const [amount, setAmount] = useState("");
    const [transactionHistory, setTransactionHistory] = useState([]); // Transaction History state
    const correctPassword = "1234"; // Set your desired password here

    // Function to handle password submission
    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        if (password === correctPassword) {
            setShowPasswordModal(false); // Hide password modal
            setShowAccountForm(true); // Show account creation form
            setPassword('');
            setErrorMessage('');
        } else {
            setErrorMessage('Incorrect password. Try again.');
        }
    };

    // Function to add a new account
    const handleAddAccount = () => {
    // Check if all fields are filled
    if (!newAccount.name || !newAccount.email || newAccount.balance <= 0) {
        alert('Please fill in all fields for the new account.');
        return;
    }
    // Check if email contains ".com"
    if (!newAccount.email.includes(".com")) {
        alert('Please enter a valid email address with ".com".');
        return;
    }
    // Add the account if all validations pass
    setAccounts([...accounts, { id: accounts.length + 1, ...newAccount }]);
    setNewAccount({ name: '', email: '', balance: 0 }); // Clear form fields after adding
    setShowAccountForm(false); // Hide account form after adding the account
    };

    // Function to delete an account
    const handleDeleteAccount = (accountId) => {
        setAccounts(accounts.filter(account => account.id !== accountId));
    };

    // Function to deposit money into the selected account
    const handleDeposit = () => {
        if (selectedAccount && transaction.amount > 0) {
            const updatedAccounts = accounts.map(account =>
                account.id === selectedAccount
                    ? { ...account, balance: account.balance + transaction.amount }
                    : account
            );
            setAccounts(updatedAccounts);
            
            // Add transaction to history
            const transactionRecord = {
                type: 'Deposit',
                amount: transaction.amount,
                account: findAccountById(selectedAccount).name,
                date: new Date().toLocaleString()
            };
            setTransactionHistory([...transactionHistory, transactionRecord]);
            setTransaction({ amount: 0, accountId: null });
        } else {
            alert('Please select an account and enter a valid deposit amount.');
        }
    };

    // Function to withdraw money from the selected account
    const handleWithdraw = () => {
        if (selectedAccount && transaction.amount > 0) {
            const account = accounts.find(account => account.id === selectedAccount);
            if (account && account.balance >= transaction.amount) {
                const updatedAccounts = accounts.map(account =>
                    account.id === selectedAccount
                        ? { ...account, balance: account.balance - transaction.amount }
                        : account
                );
                setAccounts(updatedAccounts);

    // Add transaction to history
    const transactionRecord = {
        type: 'Withdraw',
        amount: transaction.amount,
        account: findAccountById(selectedAccount).name,
        date: new Date().toLocaleString()
        };
            setTransactionHistory([...transactionHistory, transactionRecord]);
            setTransaction({ amount: 0, accountId: null });
        } else {
            alert('Insufficient funds for withdrawal.');
        }
        } else {
            alert('Please select an account and enter a valid withdrawal amount.');
        }
    };

    // Function to handle money transfer
    const handleTransfer = () => {
        const newAmount = Number(amount);
        if (userExist(sender) && userExist(receiver) && sender !== receiver && newAmount > 0) {
            const senderAccount = findAccountByName(sender);
            if (senderAccount.balance >= newAmount) {
                const updatedAccounts = accounts.map(account => {
                    if (account.name === sender) {
                        return { ...account, balance: account.balance - newAmount };
                    } else if (account.name === receiver) {
                        return { ...account, balance: account.balance + newAmount };
                    }
                    return account;
                });
                setAccounts(updatedAccounts);

                // Add transfer to history
                const transactionRecord = {
                    type: 'Transfer',
                    amount: newAmount,
                    sender,
                    receiver,
                    date: new Date().toLocaleString()
                };
                setTransactionHistory([...transactionHistory, transactionRecord]);

                // Clear the form
                setSender("");
                setReceiver("");
                setAmount("");
                setShowTransfer(false); // Hide transfer form after completing transfer
            } else {
                alert("Not enough balance for the transfer.");
            }
        } else {
            alert("Invalid transfer details. Please check and try again.");
        }
    };

    // function to check if a user exists by name
    const userExist = (name) => {
        return accounts.find((account) => account.name === name);
    };

    // function to find a user by account id
    const findAccountById = (id) => {
        return accounts.find(account => account.id === id);
    };

    // function to find a user by account name
    const findAccountByName = (name) => {
        return accounts.find(account => account.name === name);
    };

    return (
        <div className="accounts-container">
            <h3>Bank Accounts</h3>
            <div className="accounts-table">
                <div className="header-row">
                    <div>Name</div>
                    <div>Email</div>
                    <div>Funds</div>
                    <div>Actions</div>
                </div>
                {accounts.map(account => (
                    <div key={account.id} className="account-row">
                        <div>{account.name}</div>
                        <div>{account.email}</div>
                        <div>{new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(account.balance)}</div>
                        <div>
                        <button onClick={() => handleDeleteAccount(account.id)} className="delete-btn">
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                    </div>

                    </div>
                ))}
            </div>
            <div className="actions-section">
                <button onClick={() => setShowPasswordModal(true)} className="modal-btn">
                    <i class="fa-regular fa-user"></i>
                    Add Account
                </button>
            </div>

             {/* Password Modal */}
             {showPasswordModal && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>Enter Password</h3>
                        <form onSubmit={handlePasswordSubmit}>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password"
                                required
                            />
                            <button type="submit">Submit</button>
                        </form>
                        {errorMessage && <p className="error-message">{errorMessage}</p>}
                    </div>
                </div>
            )}

            {/* Account Creation Form */}
            {showAccountForm && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>Create New Account</h3>
                        <input
                            type="text"
                            placeholder="Name"
                            value={newAccount.name}
                            onChange={(e) => setNewAccount({ ...newAccount, name: e.target.value })}
                        />
                        <input
                            type="email"
                            placeholder="Email"
                            value={newAccount.email}
                            onChange={(e) => setNewAccount({ ...newAccount, email: e.target.value })}
                        />
                        <input
                            type="number"
                            placeholder="Initial Balance"
                            value={newAccount.balance}
                            onChange={(e) => setNewAccount({ ...newAccount, balance: parseFloat(e.target.value) || 0 })}
                        />
                        <button onClick={handleAddAccount} className="modal-btn">Add Account</button>
                        <button onClick={() => setShowAccountForm(false)} className="modal-btn">Cancel</button>
                    </div>
                </div>
            )}

            {/* Transaction Section */}
            <div className="transaction-section">
                <h3>Bank Transactions</h3>
                <select onChange={(e) => setSelectedAccount(parseInt(e.target.value))} value={selectedAccount || ''}>
                    <option value="">Select Account</option>
                    {accounts.map(account => (
                        <option key={account.id} value={account.id}>{account.name}</option>
                    ))}
                </select>
                <input
                    type="number"
                    placeholder="Amount"
                    value={transaction.amount}
                    onChange={(e) => setTransaction({ ...transaction, amount: parseFloat(e.target.value) || 0 })}
                />
                <div className="modal-btn-container">
                    <button onClick={handleDeposit} className="modal-btn">
                        <i class="fa-solid fa-piggy-bank"></i>
                        Deposit
                    </button>
                    <button onClick={handleWithdraw} className="modal-btn">
                        <i class="fa-solid fa-money-bill-trend-up"></i>
                        Withdraw
                    </button>
                </div>

                {/* Transfer Section */}
                <button onClick={() => setShowTransfer(!showTransfer)} className="modal-btn">
                    <i class="fa-solid fa-money-bill-transfer"></i>
                    Transfer
                </button>
                {showTransfer && (
                    <div className="transfer-form">
                        <h3>Transfer Money</h3>
                        <input
                            type="text"
                            placeholder="Sender"
                            value={sender}
                            onChange={(e) => setSender(e.target.value)}
                        />
                        <input
                            type="text"
                            placeholder="Receiver"
                            value={receiver}
                            onChange={(e) => setReceiver(e.target.value)}
                        />
                        <input
                            type="number"
                            placeholder="Amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                        <button onClick={handleTransfer} className="modal-btn">Confirm Transfer</button>
                    </div>
                )}
            </div>

            {/* Transaction History */}
            <div className="transaction-history">
                <h3>Transaction History</h3>
                <table>
                    <thead>
                        <tr className="trh">
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Account</th>
                            <th>Sender</th>
                            <th>Receiver</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactionHistory.map((transaction, index) => (
                            <tr key={index}>
                            <td data-label="Type">{transaction.type}</td>
                            <td data-label="Amount">{new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(transaction.amount)}</td>
                            <td data-label="Account">{transaction.account || '-'}</td>
                            <td data-label="Sender">{transaction.sender || '-'}</td>
                            <td data-label="Receiver">{transaction.receiver || '-'}</td>
                            <td data-label="Date">{transaction.date}</td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Accounts;
